<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" class="button" @click="$router.go(-1)">返回</button>
			</p>
			<p>
				<hr style="margin: .5rem;" />
				<span class="red"> {{booksName}}</span>
				<button type="button" class="button add" @click="add">+新增图书</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>图书编号</th>
						<th>当前位置</th>
						<th>原始位置</th>
						<th>图书状态</th>
						<th>录入时间</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in books">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.BooksNumCode}}
						</td>
						<td>
							{{ i.ShopName+':'+ i.CurrentPlace}}
						</td>
						<td>
							{{ i.OriginalShopName+':'+ i.OriginalCurrentPlace}}
						</td>
						<td>
							{{bookSate[i.BooksSate]}}
						</td>
						<td>
							{{$moment(i.OperationTime).format('YYYY年MM月DD日')}}-<span class="red">
								{{($moment(new Date()).diff($moment(i.OperationTime), 'days')+1) +'天'}}
							</span>
						</td>
						<td>
							<button type="button" @click="updateBookDetail(i)" class="button">修改</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
		<div class="booksMangement" v-show="Edit!=''">
			<div>
				<div>
					<span class="red">*</span>图书编码:
				</div>
				<div>
					<input type="text" v-model="BooksNumCode" required="required" />
					<span class="err">{{BooksNumCode>0?' ':'×'}}</span>
				</div>


				<div>
					<span class="red">*</span>图书条码:
				</div>
				<div>
					<input type="text" v-model="BooksISBN" required="required" />
					<span class="err">{{BooksISBN.length>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>图书规格:
				</div>
				<div>
					<input type="text" v-model="Size" />
					<span class="err">{{Size.length>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>出版商:
				</div>
				<div>
					<input type="text" v-model="Publisher" />
					<span class="err">{{Publisher.length>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>出版时间:
				</div>
				<div>
					<input type="text" v-model="PublicationTime" title="出版时间" placeholder="格式:2021-01-01" />
					<span class="err">{{PublicationTime.length>0?' ':'×'}}</span>
				</div>

				<div v-if="showPrice">
					<span class="red">*</span>购入价格:
				</div>
				<div v-if="showPrice">
					<input type="text" v-model="BookMoney" title="购入价格" />
					<span class="err">{{BookMoney>0?' ':'×'}}</span>
				</div>

				<div v-show="$store.state.user.UserType<=2">
					<span class="red">*</span>图书价格:
				</div>
				<div v-show="$store.state.user.UserType<=2">
					<input type="text" v-model="BookPrice" title="书籍单价" />
					<span class="err">{{BookPrice>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>购买时间:
				</div>
				<div>
					<input type="text" v-model="BuyDate" title="购入时间" placeholder="格式:2021-01-01" />
					<span class="err">{{ $uil.checkDate(BuyDate)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>归属店铺:
				</div>
				<div>
					<select v-model="ShopID" :disabled="$store.state.user.ShopType>0">
						<option v-for="i in $store.state.shop" :value="i.ShopID">{{i.ShopName}}</option>
					</select>
					<span class="err">{{ ShopID>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>归属位置:
				</div>
				<div>
					<input type="text" v-model="CurrentPlace" title="归属位置" placeholder="格式:A0区01柜01层01格" />
					<span class="err">{{ CurrentPlace.length>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>图书状态:
				</div>
				<div>
					<select v-model="BooksSate">
						<option value="0">正常</option>
						<option value="1">下架</option>
						<option value="2">借出</option>
					</select>

				</div>

				<div>
					<span class="red">*</span>备注:
				</div>
				<div>
					<textarea v-model="BooksDesc" title="备注" class="bookBaseInfor" style="height: 5rem;">

					</textarea>

				</div>

				<div>

				</div>
				<div>

					<button class="button" :class="{'disabled':!checkBooks}" :disabled="!checkBooks"
						@click="editBooksDetail">{{ BookDetailID==0?'新增':'修改'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="Edit=''">取消</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
